export default __webpack_public_path__ + "src/components/pages/shared/images/fa9ae7f57cf2ace23750bd682e7ff8c4.png";